// One primary action per device (the brief, "One primary action"). Desktop: Play (the app; without it, the download
// page), with "Play in browser" quieter beside it. Phone or tablet: "Play in browser" alone as the loud button (the
// shell's `.slide-actions .app-play` / `.btn.web-play` rules swap them), or, for a game only the app can run, a
// plain line and a quiet Get Banger link: never a desktop download as the big button.

import { isComingSoon, type Game } from "../../catalogue.ts";
import { browserPlayLink, playButton } from "../../components.ts";
import { h, link } from "../../dom.ts";

export type PhonePlay = "browser" | "app-only" | "soon";

/** What a phone gets as its action. */
export function phonePlay(g: Pick<Game, "status" | "runtime" | "url">): PhonePlay {
  if (isComingSoon(g)) return "soon";
  return g.runtime === "web" && /^https:\/\//.test(g.url) ? "browser" : "app-only";
}

/** True when a web game says how it's played and touch isn't one of the ways: phones get a heads-up. */
export function wantsKeyboard(g: Pick<Game, "facets">): boolean {
  const input = g.facets?.input ?? [];
  return input.length > 0 && !input.includes("touch");
}

export function titleActions(g: Game): HTMLElement {
  const kind = phonePlay(g);
  if (kind === "soon") return h("div", { class: "slide-actions gt-actions" }, playButton(g, "big"));
  const app = playButton(g, "big");
  app.classList.add("app-play");
  if (kind === "browser") {
    const web = browserPlayLink(g, "btn ghost web-play")!;
    return h(
      "div",
      { class: "gt-action-block" },
      h("div", { class: "slide-actions gt-actions" }, app, web),
      wantsKeyboard(g) ? h("p", { class: "gt-phone-only gt-phone-note" }, "Made for a keyboard and mouse: it may not play well on a phone.") : null,
    );
  }
  return h(
    "div",
    { class: "gt-action-block" },
    h("div", { class: "slide-actions gt-actions" }, app),
    h("p", { class: "gt-phone-only gt-phone-note" }, "Plays in the Banger app on a computer. ", link("/download", { class: "gt-quiet-link" }, "Get Banger")),
  );
}
